export const diagnosticRouteDef = [
    {
        path: ':id/:resource/viewresult',
        component: 'ViewRadioResultEntryComponent',
        data: {
            selector: 'app-view-radio-result-entry'
        }
    },
    {
        path: 'update/review_cosigner_document',
        component: "ReviewCosignerDocumentsComponent",
        data: {
            selector: 'app-review-cosigner-documents'
        }
    },
    {
        path: ':id/:resource/templateTest',
        component: 'DiagnosticTemplateComponent',
        data: {
            selector: 'app-diagnostic-template'
        }
    },
    {
        path: ':id/:resource/collectsample',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: ':id/:resource/acknowledge',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: ':id/:resource/resultTrail',
        component: 'ResultTrailComponent',
        data: {
            selector: 'app-result-trail'
        }
    },
    {
        path: ':id/:resource/order',
        component: 'EditableGridWithBannerComponent',
        data: {
            selector: 'kx-editable-grid-with-banner'
        }
    },
    {
        path: 'upload',
        component: 'BulkuploaddiagComponent',
        data: {
            selector: 'app-bulkuploaddiag'
        }
    },
    {
        path: ':context/bpmn/create',
        component: 'BpmnEngineComponent',
        data: {
            selector: 'kx-bpmn-engine'
        }
    },
    {
        path: ':context/bpmn/:subDepartment/create',
        component: 'BpmnEngineComponent',
        data: {
            selector: 'kx-bpmn-engine'
        }
    },
    {
        path: ':id/:resource/dicomviewer',
        component: 'DiacomViewerComponent',
        data: {
            selector: 'diacom-viewer',
            config: {
                "type": "checkFromRes",
                datasource: {
                    "application": "diagnostic",
                    "resource": "radio",
                    "args": "serviceRequestId:!!!serviceRequestId!!!",
                    "queryId": "GET_PACS_IMAGE_ID_OR_URL"
                }
            }
        }
    },
    {
        path: ':id/:resource/dcmview',
        component: 'DiagnosticDicomViewerComponent',
        data: {
            selector: 'app-diagnostic-dicom-viewer',
            config: {
                "type": "checkFromRes",
                datasource: {
                    "application": "diagnostic",
                    "resource": "radio",
                    "args": "serviceRequestId:!!!serviceRequestId!!!",
                    "queryId": "GET_PACS_IMAGE_ID_OR_URL"
                }
            }
        }
    },
    {
        path: ':id/:resource/resultentry',
        component: 'ResultEntryComponent',
        data: {
            selector: 'app-result-entry'
        }
    },
    {
        path: ':id/:resource/resultdefinalize',
        component: 'ResultEntryComponent',
        data: {
            selector: 'app-result-entry'
        }
    },
    {
        path: ':id/:resource/resultverification',
        component: 'ResultEntryComponent',
        data: {
            selector: 'app-result-entry'
        }
    },
    {
        path: ':id/:resource/amendresult',
        component: 'ResultEntryComponent',
        data: {
            selector: 'app-result-entry'
        }
    },
    {
        path: ':id/:resource/amend',
        component: 'ResultEntryComponent',
        data: {
            selector: 'app-result-entry'
        }
    },
    {
        path: ':id/:resource/radioresultentry',
        component: 'RadioAdvancetextEntryComponent',
        data: {
            selector: 'app-radio-advancetext-entry'
        }
    },
    {
        path: ':id/:resource/radioamendreport',
        component: 'RadioAdvancetextEntryComponent',
        data: {
            selector: 'app-radio-advancetext-entry'
        }
    },
    {
        path: ':id/:resource/radioresultverification',
        component: 'RadioAdvancetextEntryComponent',
        data: {
            selector: 'app-radio-advancetext-entry'
        }
    },
    {
        path: ':id/:resource/radioresultdefinalize',
        component: 'RadioAdvancetextEntryComponent',
        data: {
            selector: 'app-radio-advancetext-entry'
        }
    },

    {
        path: ':id/:resource/orgresultentry',
        component: 'OrganismResultEntryComponent',
        data: {
            selector: 'app-organism-result-entry'
        }
    },
    {
        path: ':id/:resource/orgresultentrysequencing',
        component: 'OrganismResultEntryComponent',
        data: {
            selector: 'app-organism-result-entry'
        }
    },
    {
        path: ':id/:resource/orgresultverification',
        component: 'OrganismResultEntryComponent',
        data: {
            selector: 'app-organism-result-entry'
        }
    },
    {
        path: ':id/:resource/orgresultverificationsequence',
        component: 'OrganismResultEntryComponent',
        data: {
            selector: 'app-organism-result-entry'
        }
    },
    {
        path: ':id/:resource/orgresultdefinalize',
        component: 'OrganismResultEntryComponent',
        data: {
            selector: 'app-organism-result-entry'
        }
    },
    {
        path: ':id/:resource/orgamendresult',
        component: 'OrganismResultEntryComponent',
        data: {
            selector: 'app-organism-result-entry'
        }
    },
    {
        path: ':id/:resource/templateView',
        component: 'ViewTemplateComponent',
        data: {
            selector: 'app-view-template'
        }
    },
    {
        path: ':resource/editdata/list',
        component: 'FormGridComponent',
        data: {
            selector: 'dhs-form-grid'
        }
    },
    {
        path: 'patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_patient_track_diagnostic'
        }
    },
    {
        path: 'patient_clearence_radio',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_item_track_radiology'
        }
    },
    {
        path: 'patient_clearence_pulmonology',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_item_track_pulmonology'
        }
    },
    {
        path: 'patient_clearence_cardiology',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_item_track_cardiology'
        }
    },
    {
        path: 'patient_clearence_neurology',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_item_track_neurology'
        }
    },
    {
        path: 'patient_clearence_nuclear_medicine',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_item_track_nuclear_medicine'
        }
    },
    {
        path: ':id/:resource/cancelFullOrder',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: ':id/:resource/cancelPartialOrder',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: 'patient_clearence_ris_clinical_services',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_item_track_ris_clinical_services'
        }
    },
    {
        path: ':id/orderTrack',
        component: 'PatientOrderDashboard',
        data: {
            selector: 'app-patient-order-dashboard',
            resource: 'per_patient_track_order',
            requiredFilters: ['uhId']
        }
    },
    {
        path: ':id/:resource/cryoresultentry',
        component: 'CryoResultEntryComponent',
        data: {
            selector: 'app-cryo-result-entry'
        }
    },
    {
        path: ':id/:resource/cryoresultverification',
        component: 'CryoResultEntryComponent',
        data: {
            selector: 'app-cryo-result-entry'
        }
    },
    {
        path: ':id/:resource/cryoamendresult',
        component: 'CryoResultEntryComponent',
        data: {
            selector: 'app-cryo-result-entry'
        }
    },
    {
        path: ':id/:resource/acknowledgeOutsource',
        component: 'DiagnosticEditableGridComponent',
        data: {
            selector: 'app-diagnostic-editable-grid'
        }
    },
    {
        path: ':id/definalizeHistory',
        component: 'PatientOrderDashboard',
        data: {
            selector: 'app-patient-order-dashboard',
            resource: 'per_patient_track_definalized_reports',
            requiredFilters: []
        }
    },
    {
        path: 'uploadedfile_metadata',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'lab_view_upload_document',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: 'uploadedfile_metadata_order',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'lab_view_upload_document_order',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: 'histo_uploadedfile_metadata',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'histo_view_upload_document',
            action: 'IMAGE_VIEWER',
        }
    }
]